// extracted by mini-css-extract-plugin
export default {"btnFollow":"FollowButton_btnFollow__cvyoa","btnFollowing":"FollowButton_btnFollowing__M1H-m"};